import { message as antdMessage } from "antd";

// Long timeout for AI-backed endpoints (Apply, internal apply, explore,
// round complete, feedback). These calls hit an external AI service for
// talent-profile generation, fit-score calculation, and re-scoring, so
// they take noticeably longer than normal CRUD requests.
export const AI_TIMEOUT = 180000; // 3 minutes

const AI_MESSAGES = [
  "Analyzing candidate profile…",
  "Generating AI evaluation…",
  "Calculating fit score…",
  "Please wait, this may take a few moments…",
];

// Show a rotating AI-friendly loading toast and return a stop() callback.
// Use in any call site that hits an AI-backed endpoint:
//   const stop = startAILoading();
//   try { ... } finally { stop(); }
export function startAILoading(intervalMs = 6000) {
  let i = 0;
  const key = `ai-loading-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
  antdMessage.loading({ content: AI_MESSAGES[i], key, duration: 0 });
  const handle = setInterval(() => {
    i = (i + 1) % AI_MESSAGES.length;
    antdMessage.loading({ content: AI_MESSAGES[i], key, duration: 0 });
  }, intervalMs);
  return () => {
    clearInterval(handle);
    antdMessage.destroy(key);
  };
}
